import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** heart. Decorative line icon; always pair with a visible text label. */
export function HeartIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M12 20.2S3.6 15.3 2.6 10A4.9 4.9 0 0 1 12 6.6 4.9 4.9 0 0 1 21.4 10c-1 5.3-9.4 10.2-9.4 10.2z" />
    </IconSvg>
  )
}
